export const socialsData = {
    github: 'https://github.com/PrattayDhar/',
    facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/prattaydharlogna/',
    instagram: 'https://www.instagram.com/',
    codepen: 'https://codepen.io/',
    twitter: 'https://twitter.com/PrattayDL',
    reddit: 'https://www.reddit.com/user/',
    blogger: 'https://www.blogger.com/',
    medium: 'https://medium.com/@',
    stackOverflow: 'https://stackoverflow.com/users/',
    gitlab: 'https://gitlab.com/',
    youtube: 'https://youtube.com/'
}